export const CONTENT_PAGE = [
    {
        blockName: 'constellation/group',
        attrs: {
            margin: {
                type: 'object',
                default: {
                    marginBottom: {
                        default: 'none',
                        lg_lte: 'none',
                        sm_lte: 'none',
                    },
                },
            },
            padding: {
                type: 'object',
                default: {
                    paddingTop: {
                        default: 'none',
                        lg_lte: 'none',
                        sm_lte: 'none',
                    },
                    paddingBottom: {
                        default: 'none',
                        lg_lte: 'none',
                        sm_lte: 'none',
                    },
                    paddingRight: {
                        default: 'none',
                        lg_lte: 'none',
                        sm_lte: 'none',
                    },
                    paddingLeft: {
                        default: 'none',
                        lg_lte: 'none',
                        sm_lte: 'none',
                    },
                },
                paddingLeft: {
                    default: 'md',
                    lg_lte: '0',
                    sm_lte: '0',
                },
                paddingRight: {
                    default: 'md',
                    lg_lte: '0',
                    sm_lte: '0',
                },
            },
            metadata: {
                name: 'Page Wrapper',
            },
            id: 'group-763d1950-97fd-487f-9f17-8746272f117c',
        },
        innerBlocks: [
            {
                blockName: 'constellation/group',
                attrs: {
                    alignItems: {
                        default: 'stretch',
                        lg_lte: 'flex-start',
                        sm_lte: 'center',
                    },
                    backgroundColor: {
                        default: 'backgroundWhite',
                    },
                    backgroundImage: {
                        default: [],
                        lg_lte: [],
                        sm_lte: {
                            alt: '',
                            id: 3259,
                            link: 'https://cms-bedrock-prod.int.zgcp-consumer-prod-k8s.zg-int.net/constellation/?attachment_id=3259',
                            caption: '',
                            src: 'https://www.zillowstatic.com/bedrock/app/uploads/sites/10/2024/01/Capture.png',
                            sizeSlug: 'large',
                            width: 97,
                            height: 76,
                        },
                    },
                    backgroundImageVisible: {
                        default: false,
                        lg_lte: false,
                        sm_lte: false,
                    },
                    backgroundPosition: {
                        default: '0% 0%',
                        lg_lte: '100% 0%',
                    },
                    justifyContent: {
                        default: 'center',
                        sm_lte: 'flex-start',
                    },
                    margin: {
                        marginBottom: {
                            lg_lte: 'md',
                            sm_lte: '0',
                        },
                        marginTop: {
                            default: 'md',
                            sm_lte: '0',
                        },
                    },
                    maxWidth: {
                        default: 'full',
                        sm_lte: 'full',
                    },
                    minHeight: {
                        default: 'none',
                        lg_lte: 'none',
                        sm_lte: 'none',
                    },
                    objectPosition: {
                        default: {
                            x: 0,
                            y: 0,
                        },
                        lg_lte: {
                            x: 100,
                            y: 0,
                        },
                    },
                    padding: {
                        paddingRight: {
                            default: 'sm',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingLeft: {
                            default: 'sm',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingTop: {
                            sm_lte: '0',
                            default: 'md',
                        },
                        paddingBottom: {
                            sm_lte: 'md',
                        },
                    },
                    className: 'phase-0 phase-1',
                    metadata: {
                        name: 'Mortgage Rates Hero',
                    },
                    id: 'group-7b6e9c76-d2ed-4259-b90e-35231aa8daf81',
                },
                innerBlocks: [
                    {
                        blockName: 'constellation/group',
                        attrs: {
                            alignItems: {
                                default: 'flex-start',
                                sm_lte: 'stretch',
                            },
                            backgroundPosition: {
                                default: '0% 53%',
                            },
                            justifyContent: {
                                default: 'center',
                                sm_lte: 'center',
                            },
                            margin: {
                                marginBottom: {
                                    default: 'sm',
                                    sm_lte: '0',
                                },
                                marginTop: [],
                            },
                            maxWidth: {
                                default: 'xl',
                                lg_lte: 'lg',
                                sm_lte: 'full',
                            },
                            objectPosition: {
                                default: {
                                    x: 0,
                                    y: 53,
                                },
                            },
                            padding: {
                                paddingTop: {
                                    default: 'sm',
                                    lg_lte: 'sm',
                                    sm_lte: 'sm',
                                },
                                paddingBottom: {
                                    lg_lte: 'sm',
                                    sm_lte: '0',
                                },
                                paddingRight: {
                                    default: 'xs',
                                    lg_lte: 'xxl',
                                    sm_lte: '0',
                                },
                                paddingLeft: {
                                    default: 'xs',
                                    lg_lte: 'xxl',
                                    sm_lte: '0',
                                },
                            },
                            id: 'group-48e68d9e-a49d-450e-ae95-0a3cfab5c13a',
                        },
                        innerBlocks: [
                            {
                                blockName: 'constellation/grid-layout',
                                attrs: {
                                    gap: {
                                        default: 'xl',
                                        lg_lte: 'md',
                                        sm_lte: 'md',
                                    },
                                    justifyContent: {
                                        default: 'stretch',
                                        lg_lte: 'start',
                                        sm_lte: 'center',
                                    },
                                    alignItems: {
                                        default: 'None',
                                        lg_lte: 'start',
                                        sm_lte: 'center',
                                    },
                                    id: 'grid-layout-228b9ea4-b24b-4d52-a57f-39efd896bb7b',
                                },
                                innerBlocks: [
                                    {
                                        blockName: 'constellation/grid-content',
                                        attrs: {
                                            gridColumnEnd: {
                                                default: 'span 6',
                                                lg_lte: 'span 12',
                                                sm_lte: 'span 12',
                                            },
                                            alignSelf: {
                                                default: 'center',
                                                sm_lte: 'None',
                                            },
                                            alignItems: {
                                                default: 'stretch',
                                                lg_lte: 'center',
                                                sm_lte: 'stretch',
                                            },
                                            justifyContent: {
                                                default: 'flex-start',
                                                sm_lte: 'flex-start',
                                            },
                                            order: {
                                                lg_lte: '1',
                                            },
                                            id: 'grid-content-f7fc3786-e0c7-49f5-a397-a956a4639d56',
                                        },
                                        innerBlocks: [
                                            {
                                                blockName:
                                                    'constellation/group',
                                                attrs: {
                                                    alignItems: {
                                                        default: 'stretch',
                                                        lg_lte: 'center',
                                                    },
                                                    margin: {
                                                        marginBottom: {
                                                            lg_lte: '0',
                                                            sm_lte: 'sm',
                                                        },
                                                    },
                                                    maxWidth: {
                                                        default: 'full',
                                                    },
                                                    padding: {
                                                        paddingTop: {
                                                            lg_lte: 'md',
                                                            sm_lte: 'sm',
                                                        },
                                                        paddingBottom: {
                                                            lg_lte: '0',
                                                            sm_lte: 'sm',
                                                        },
                                                        paddingRight: {
                                                            default: 'xl',
                                                            lg_lte: '0',
                                                            sm_lte: '0',
                                                        },
                                                        paddingLeft: {
                                                            lg_lte: '0',
                                                            sm_lte: '0',
                                                        },
                                                    },
                                                    id: 'group-54dbcfee-e9a7-4c73-9cea-3f038518cb56',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/heading',
                                                        attrs: {
                                                            content:
                                                                '<span class="constellation-text-color constellation-text--textDark" color="textDark">Current</span><span class="constellation-text-color constellation-text--textBrand" color="textBrand"> {State}</span> mortgage rates',
                                                            fontType: {
                                                                default: 'h2',
                                                                sm_lte: 'h3',
                                                            },
                                                            as: 'h1',
                                                            margin: {
                                                                marginTop: {
                                                                    sm_lte: '0',
                                                                },
                                                                marginBottom: {
                                                                    default:
                                                                        'md',
                                                                },
                                                            },
                                                            fontFamily: 'serif',
                                                            textAlign: {
                                                                default:
                                                                    'inherit',
                                                                lg_lte: 'center',
                                                                sm_lte: 'center',
                                                            },
                                                            id: 'heading-hero',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<h1><span class="constellation-text-color constellation-text--textDark" color="textDark">Current</span><span class="constellation-text-color constellation-text--textBrand" color="textBrand"> {State}</span> mortgage rates</h1>',
                                                        innerContent: [],
                                                    },
                                                    {
                                                        blockName:
                                                            'constellation/paragraph',
                                                        attrs: {
                                                            content:
                                                                'Buying a home in {State} starts with understanding rates. Explore Zillow Home Loans rates in {State} or get pre-approved to get a personalized rate.',
                                                            fontType: 'large',
                                                            textAlign: {
                                                                default:
                                                                    'inherit',
                                                                lg_lte: 'center',
                                                                sm_lte: 'center',
                                                            },
                                                            margin: {
                                                                marginBottom: {
                                                                    sm_lte: '-lg',
                                                                },
                                                            },
                                                            id: 'sub-heading-hero',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<p>Buying a home in {State} starts with understanding rates. Explore Zillow Home Loans rates in {State} or get pre-approved to get a personalized rate.</p>',
                                                        innerContent: [],
                                                    },
                                                ],
                                                innerHTML: '\n\n\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-layout',
                                                attrs: {
                                                    id: 'grid-layout-413544c6-1e9c-4eac-ba0a-7a0093e01dbf',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/grid-content',
                                                        attrs: {
                                                            gridColumnEnd: {
                                                                default:
                                                                    'span 11',
                                                                lg_lte: 'span 12',
                                                                sm_lte: 'span 12',
                                                            },
                                                            justifySelf: {
                                                                sm_lte: 'center',
                                                            },
                                                            alignItems: {
                                                                default:
                                                                    'flex-start',
                                                                lg_lte: 'center',
                                                            },
                                                            id: 'grid-content-326d242f-8267-44e1-bfc2-bf5bdaba5256',
                                                        },
                                                        innerBlocks: [
                                                            {
                                                                blockName:
                                                                    'constellation/button-group',
                                                                attrs: {
                                                                    fluid: {
                                                                        default:
                                                                            true,
                                                                        sm_lte: true,
                                                                    },
                                                                    alignItems:
                                                                        {
                                                                            default:
                                                                                'flex-start',
                                                                            sm_lte: 'center',
                                                                        },
                                                                    justifyContent:
                                                                        {
                                                                            default:
                                                                                'flex-start',
                                                                            sm_lte: 'center',
                                                                        },
                                                                    margin: {
                                                                        marginBottom:
                                                                            {
                                                                                sm_lte: '0',
                                                                            },
                                                                        marginTop:
                                                                            {
                                                                                sm_lte: 'xl',
                                                                                default:
                                                                                    'lg',
                                                                            },
                                                                    },
                                                                    id: 'button-prequalify-hero-v2',
                                                                },
                                                                innerBlocks: [
                                                                    {
                                                                        blockName:
                                                                            'constellation/button',
                                                                        attrs: {
                                                                            content:
                                                                                'Get pre-approved',
                                                                            size: 'lg',
                                                                            buttonType:
                                                                                'primary',
                                                                            link: {
                                                                                url: 'https://www.zillow.com/homeloans/eligibility/intro/?source=Zillow&channel=Home_Loans&utm_campaign=zhl_homeloanslp_digitalID-stateratelp-pre-approval-hero-button',
                                                                                opensInNewTab:
                                                                                    false,
                                                                            },
                                                                            id: 'button-buyability-hero',
                                                                        },
                                                                        innerBlocks:
                                                                            [],
                                                                        innerHTML:
                                                                            '',
                                                                        innerContent:
                                                                            [],
                                                                    },
                                                                ],
                                                                innerHTML:
                                                                    '\n\n',
                                                                innerContent: [
                                                                    '\n',
                                                                    null,
                                                                    '\n',
                                                                ],
                                                            },
                                                        ],
                                                        innerHTML: '\n\n',
                                                        innerContent: [
                                                            '\n',
                                                            null,
                                                            '\n',
                                                        ],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/group',
                                                attrs: {
                                                    alignItems: {
                                                        default: 'stretch',
                                                        sm_lte: 'center',
                                                    },
                                                    margin: {
                                                        marginBottom: {
                                                            default: 'lg',
                                                            lg_lte: 'md',
                                                            sm_lte: 'xl',
                                                        },
                                                    },
                                                    maxWidth: {
                                                        default: 'full',
                                                    },
                                                    padding: {
                                                        paddingTop: {
                                                            default: 'sm',
                                                            lg_lte: 'md',
                                                            sm_lte: 'sm',
                                                        },
                                                        paddingBottom: {
                                                            default: 'lg',
                                                            lg_lte: 'md',
                                                            sm_lte: 'sm',
                                                        },
                                                        paddingRight: {
                                                            lg_lte: 'md',
                                                            sm_lte: 'sm',
                                                        },
                                                        paddingLeft: {
                                                            lg_lte: '0',
                                                            sm_lte: 'sm',
                                                        },
                                                    },
                                                    id: 'group-950ff686-17b3-4bf5-9aea-ee627c1be167',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/paragraph',
                                                        attrs: {
                                                            content:
                                                                '<strong>Already working with us? <a href="https://www.zillow.com/homeloans/mortgage/dashboard/login" rel="nofollow" target="" id="link-12c6cf5b-b097-4544-9cd7-70a2819c16ad">Access your dashboard</a></strong>',
                                                            textAlign: {
                                                                default:
                                                                    'inherit',
                                                                lg_lte: 'center',
                                                                sm_lte: 'center',
                                                            },
                                                            margin: {
                                                                marginBottom: {
                                                                    sm_lte: '-xl',
                                                                },
                                                                marginTop: [],
                                                            },
                                                            id: 'dashboard-link-hero',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<p><strong>Already working with us? <a href="https://www.zillow.com/homeloans/mortgage/dashboard/login" rel="nofollow" target="" id="link-12c6cf5b-b097-4544-9cd7-70a2819c16ad">Access your dashboard</a></strong></p>',
                                                        innerContent: [],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                        ],
                                        innerHTML: '\n\n\n\n\n\n',
                                        innerContent: [
                                            '\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n',
                                        ],
                                    },
                                    {
                                        blockName: 'constellation/grid-content',
                                        attrs: {
                                            gridColumnEnd: {
                                                default: 'span 6',
                                                lg_lte: 'span 12',
                                                sm_lte: 'span 12',
                                            },
                                            justifySelf: {
                                                lg_lte: 'center',
                                            },
                                            alignSelf: {
                                                default: 'start',
                                            },
                                            alignItems: {
                                                default: 'stretch',
                                                lg_lte: 'center',
                                            },
                                            order: {
                                                lg_lte: '0',
                                            },
                                            id: 'grid-content-799e18ce-0f2b-4322-af1d-438f1bd397d6',
                                        },
                                        innerBlocks: [
                                            {
                                                blockName:
                                                    'constellation/group',
                                                attrs: {
                                                    margin: {
                                                        marginBottom: {
                                                            default: 'lg',
                                                            lg_lte: '0',
                                                            sm_lte: '0',
                                                        },
                                                    },
                                                    padding: {
                                                        paddingTop: {
                                                            lg_lte: '0',
                                                            sm_lte: 'sm',
                                                        },
                                                        paddingBottom: {
                                                            default: 'lg',
                                                            lg_lte: 'md',
                                                            sm_lte: '0',
                                                        },
                                                        paddingRight: {
                                                            lg_lte: '0',
                                                            sm_lte: 'sm',
                                                        },
                                                        paddingLeft: {
                                                            default: 'lg',
                                                            lg_lte: '0',
                                                            sm_lte: 'sm',
                                                        },
                                                    },
                                                    id: 'group-f0343c61-0c0c-43cb-a5a4-d6af05a34e05',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/image',
                                                        attrs: {
                                                            alt: '',
                                                            caption: '',
                                                            height: 356,
                                                            loading: 'eager',
                                                            mediaId: 2370,
                                                            sizeSlug: 'large',
                                                            src: 'https://www.zillowstatic.com/bedrock/app/uploads/sites/48/2025/07/mortgagerates_tablet%402x.png',
                                                            width: 497,
                                                            id: 'image-f2b9946d-724a-440b-82d6-e08bbb7be508',
                                                            srcSet: 'https://www.zillowstatic.com/bedrock/app/uploads/sites/48/2025/07/mortgagerates_tablet%402x.png 996w, https://www.zillowstatic.com/bedrock/app/uploads/sites/48/2025/07/mortgagerates_tablet%402x-360x258.png 360w',
                                                            sizes: '(max-width: 996px) 100vw, 996px',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<img src="https://www.zillowstatic.com/bedrock/app/uploads/sites/48/2025/07/mortgagerates_tablet%402x.png" alt="" width="497" height="356">',
                                                        innerContent: [],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                        ],
                                        innerHTML: '\n\n',
                                        innerContent: ['\n', null, '\n'],
                                    },
                                ],
                                innerHTML: '\n\n\n\n',
                                innerContent: ['\n', null, '\n\n', null, '\n'],
                            },
                        ],
                        innerHTML: '\n\n',
                        innerContent: ['\n', null, '\n'],
                    },
                ],
                innerHTML: '\n\n',
                innerContent: ['\n', null, '\n'],
            },
            {
                blockName: 'constellation/group',
                attrs: {
                    maxWidth: {
                        default: 'xl',
                        sm_lte: 'full',
                    },
                    padding: {
                        paddingTop: {
                            default: 'lg',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingBottom: {
                            default: 'xs',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingRight: {
                            default: 'sm',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingLeft: {
                            default: 'sm',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                    },
                    metadata: {
                        name: 'Container',
                    },
                    id: 'group-1077a45d-6545-4d75-bda4-9a290da1f3aa',
                },
                innerBlocks: [
                    {
                        blockName: 'constellation/group',
                        attrs: {
                            backgroundColor: {
                                default: 'backgroundLight',
                            },
                            borderRadius: {
                                borderRadiusTopRight: {
                                    default: 'xxl',
                                },
                                borderRadiusTopLeft: {
                                    default: 'xxl',
                                },
                                borderRadiusBottomRight: {
                                    default: 'xxl',
                                },
                                borderRadiusBottomLeft: {
                                    default: 'xxl',
                                },
                            },
                            margin: {
                                marginBottom: {
                                    lg_lte: 'md',
                                    sm_lte: 'sm',
                                },
                                marginTop: {
                                    sm_lte: '0',
                                },
                            },
                            padding: {
                                paddingTop: {
                                    lg_lte: 'md',
                                    sm_lte: '0',
                                },
                                paddingBottom: {
                                    lg_lte: 'md',
                                    sm_lte: 'sm',
                                },
                                paddingRight: {
                                    default: 'md',
                                    lg_lte: 'md',
                                    sm_lte: 'sm',
                                },
                                paddingLeft: {
                                    default: 'md',
                                    lg_lte: 'md',
                                    sm_lte: 'sm',
                                },
                            },
                            metadata: {
                                name: 'Rate Summary',
                            },
                            id: 'group-d6baed8f-9b87-400b-8515-473f1368b8d5',
                        },
                        innerBlocks: [
                            {
                                blockName: 'constellation/group',
                                attrs: {
                                    alignItems: {
                                        default: 'stretch',
                                        sm_lte: 'center',
                                    },
                                    margin: {
                                        marginBottom: {
                                            default: 'xl',
                                            lg_lte: 'md',
                                            sm_lte: '0',
                                        },
                                        marginTop: {
                                            default: 'xl',
                                            lg_lte: '0',
                                            sm_lte: 'sm',
                                        },
                                    },
                                    padding: {
                                        paddingRight: {
                                            default: 'xxl',
                                            lg_lte: 'sm',
                                            sm_lte: '0',
                                        },
                                        paddingLeft: {
                                            default: 'xxl',
                                            lg_lte: 'sm',
                                            sm_lte: '0',
                                        },
                                        paddingBottom: {
                                            default: 'md',
                                            lg_lte: 'md',
                                            sm_lte: '0',
                                        },
                                        paddingTop: {
                                            default: 'md',
                                            lg_lte: '0',
                                            sm_lte: '0',
                                        },
                                    },
                                    id: 'group-e4922ac2-6ede-44a6-8ef1-d6aef6fdab1f',
                                },
                                innerBlocks: [
                                    {
                                        blockName: 'constellation/grid-layout',
                                        attrs: {
                                            gap: {
                                                default: 'xl',
                                                lg_lte: 'sm',
                                                sm_lte: 'sm',
                                            },
                                            justifyContent: {
                                                default: 'None',
                                            },
                                            id: 'grid-layout-e456e55f-7121-4477-9c34-b17d5d8bda0a',
                                        },
                                        innerBlocks: [
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 8',
                                                        lg_lte: 'span 8',
                                                        sm_lte: 'span 12',
                                                    },
                                                    justifySelf: {
                                                        default: 'None',
                                                        lg_lte: 'stretch',
                                                    },
                                                    alignSelf: {
                                                        lg_lte: 'stretch',
                                                        sm_lte: 'None',
                                                    },
                                                    alignItems: {
                                                        default: 'flex-start',
                                                        lg_lte: 'center',
                                                    },
                                                    justifyContent: {
                                                        default: 'center',
                                                        lg_lte: 'center',
                                                    },
                                                    order: {
                                                        lg_lte: '1',
                                                        sm_lte: '1',
                                                    },
                                                    id: 'grid-content-a265b181-72e0-4e49-bf54-a38038081dd5',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/heading',
                                                        attrs: {
                                                            content:
                                                                'What are today’s {State} mortgage rates?',
                                                            fontType: {
                                                                default: 'h3',
                                                            },
                                                            margin: {
                                                                marginTop: [],
                                                                marginBottom: {
                                                                    default:
                                                                        'xs',
                                                                },
                                                            },
                                                            fontFamily: 'serif',
                                                            id: 'heading-c74cd56f-091e-4b2b-ab62-35ad51d40559',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<h2>What are today’s {State} mortgage rates?</h2>',
                                                        innerContent: [],
                                                    },
                                                    {
                                                        blockName:
                                                            'zhl/zhl-rate-summary',
                                                        attrs: {
                                                            state: '{StateAbv}',
                                                            id: 'missing-7b09f81d-b542-4b69-b4f1-0273d3cafc57',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML: '',
                                                        innerContent: [],
                                                    },
                                                ],
                                                innerHTML: '\n\n\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 3',
                                                        lg_lte: 'span 4',
                                                        sm_lte: 'span 12',
                                                    },
                                                    justifySelf: {
                                                        lg_lte: 'stretch',
                                                    },
                                                    alignSelf: {
                                                        lg_lte: 'stretch',
                                                    },
                                                    alignItems: {
                                                        default: 'flex-end',
                                                        lg_lte: 'center',
                                                    },
                                                    justifyContent: {
                                                        default: 'center',
                                                        lg_lte: 'center',
                                                    },
                                                    order: {
                                                        lg_lte: '1',
                                                        sm_lte: '0',
                                                    },
                                                    id: 'grid-content-ad29f578-9bf0-4aa3-bef5-32ef9e460ef2',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/picture',
                                                        attrs: {
                                                            desktop: {
                                                                alt: 'Illustration of dollar sign on mobile',
                                                                id: 2275,
                                                                link: 'https://cms-bedrock-prod.int.zgcp-consumer-prod-k8s.zg-int.net/homeloans/mortgage-rates/finance-option2/',
                                                                caption: '',
                                                                src: 'https://www.zillowstatic.com/bedrock/app/uploads/sites/48/2025/06/finance-option2.png',
                                                                sizeSlug:
                                                                    'large',
                                                                width: 240,
                                                                height: 240,
                                                            },
                                                            tablet: {
                                                                src: '',
                                                                alt: 'couple on phone',
                                                            },
                                                            id: 'picture-8ac12040-d747-4eff-87d3-d1963cd8896e',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML: '',
                                                        innerContent: [],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                        ],
                                        innerHTML: '\n\n\n\n',
                                        innerContent: [
                                            '\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n',
                                        ],
                                    },
                                ],
                                innerHTML: '\n\n',
                                innerContent: ['\n', null, '\n'],
                            },
                        ],
                        innerHTML: '\n\n',
                        innerContent: ['\n', null, '\n'],
                    },
                ],
                innerHTML: '\n\n',
                innerContent: ['\n', null, '\n'],
            },
            {
                blockName: 'constellation/group',
                attrs: {
                    margin: {
                        marginBottom: {
                            lg_lte: 'md',
                        },
                        marginTop: {
                            sm_lte: '0',
                        },
                    },
                    maxWidth: {
                        default: 'xl',
                        lg_lte: 'xl',
                    },
                    padding: {
                        paddingTop: {
                            lg_lte: 'md',
                            sm_lte: '0',
                        },
                        paddingBottom: {
                            lg_lte: 'md',
                        },
                        paddingRight: {
                            default: 'sm',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingLeft: {
                            default: 'sm',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                    },
                    metadata: {
                        name: 'Rate Blocks',
                    },
                    id: 'group-carousel',
                },
                innerBlocks: [
                    {
                        blockName: 'constellation/group',
                        attrs: {
                            fontColor: {
                                default: '#0041D9',
                            },
                            margin: {
                                marginBottom: {
                                    default: 'lg',
                                    lg_lte: 'md',
                                    sm_lte: '0',
                                },
                                marginTop: {
                                    sm_lte: '0',
                                },
                            },
                            maxWidth: {
                                default: 'full',
                            },
                            padding: {
                                paddingTop: {
                                    default: 'lg',
                                    lg_lte: 'md',
                                    sm_lte: '0',
                                },
                                paddingBottom: {
                                    default: 'lg',
                                    lg_lte: 'md',
                                    sm_lte: '0',
                                },
                                paddingRight: {
                                    lg_lte: '0',
                                    sm_lte: '0',
                                },
                                paddingLeft: {
                                    lg_lte: '0',
                                    sm_lte: '0',
                                },
                            },
                            id: 'group-c35430e2-14c2-4855-9773-1b852bf85568',
                        },
                        innerBlocks: [
                            {
                                blockName: 'constellation/heading',
                                attrs: {
                                    content:
                                        'Compare mortgage rates in {State}',
                                    fontType: {
                                        default: 'h3',
                                        sm_lte: 'h4',
                                    },
                                    fontFamily: 'serif',
                                    textAlign: {
                                        default: 'center',
                                    },
                                    id: 'heading-617656f4-75d0-496d-a346-0f02a8923c9d',
                                },
                                innerBlocks: [],
                                innerHTML:
                                    '<h2>Compare mortgage rates in {State}</h2>',
                                innerContent: [],
                            },
                            {
                                blockName: 'zhl/zhl-rate-cards',
                                attrs: {
                                    state: '{StateAbv}',
                                    layout: 'tabbed',
                                    whiteCardButtonLink:
                                        'https://www.zillow.com/homeloans/eligibility/?source=Zillow&channel=Home_Loans&utm_campaign=zhl_homeloanslp_digitalID-stateratelp-pre-approval-loan-card-button',
                                    modalButtonLink:
                                        'https://www.zillow.com/homeloans/eligibility/?source=Zillow&channel=Home_Loans&utm_campaign=zhl_homeloanslp_digitalID-stateratelp-pre-approval-sample-loan-terms-cta',
                                    blueCardLink:
                                        'https://www.zillow.com/homeloans/buyability?source=Zillow&channel=Home_Loans&utm_campaign=zhl_homeloanslp_digitalID-stateratelp-pre-approval-personalized-rate-button',
                                    blueCardHeader: ' ',
                                    id: 'missing-9b4d283f-1006-48cc-960b-a2afcff9ae72',
                                },
                                innerBlocks: [],
                                innerHTML: '',
                                innerContent: [],
                            },
                        ],
                        innerHTML: '\n\n\n\n',
                        innerContent: ['\n', null, '\n\n', null, '\n'],
                    },
                ],
                innerHTML: '\n\n',
                innerContent: ['\n', null, '\n'],
            },
            {
                blockName: 'constellation/group',
                attrs: {
                    fontColor: {
                        default: 'textWhite',
                    },
                    padding: {
                        paddingTop: {
                            default: 'lg',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingBottom: {
                            default: 'lg',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingRight: {
                            default: 'sm',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingLeft: {
                            default: 'sm',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                    },
                    metadata: {
                        name: 'Container',
                    },
                    id: 'group-ca212cba-555b-4d32-a4c2-dc0f52f4f905',
                },
                innerBlocks: [
                    {
                        blockName: 'constellation/group',
                        attrs: {
                            alignItems: {
                                default: 'center',
                            },
                            backgroundColor: {
                                default: 'backgroundTeal',
                            },
                            borderRadius: {
                                borderRadiusTopRight: {
                                    default: 'xxl',
                                },
                                borderRadiusTopLeft: {
                                    default: 'xxl',
                                },
                                borderRadiusBottomRight: {
                                    default: 'xxl',
                                },
                                borderRadiusBottomLeft: {
                                    default: 'xxl',
                                },
                            },
                            fontColor: {
                                default: 'textWhite',
                            },
                            justifyContent: {
                                default: 'center',
                                lg_lte: 'center',
                            },
                            margin: {
                                marginBottom: [],
                                marginTop: {
                                    lg_lte: '-md',
                                },
                            },
                            maxWidth: {
                                default: 'xl',
                                lg_lte: 'xl',
                                sm_lte: 'sm',
                            },
                            padding: {
                                paddingTop: {
                                    default: 'md',
                                    sm_lte: 'sm',
                                },
                                paddingBottom: {
                                    sm_lte: 'sm',
                                },
                                paddingRight: {
                                    lg_lte: 'lg',
                                    sm_lte: 'xs',
                                },
                                paddingLeft: {
                                    lg_lte: 'lg',
                                    sm_lte: 'xs',
                                },
                            },
                            metadata: {
                                name: 'How to get lower rates',
                            },
                            id: 'how-it-works',
                        },
                        innerBlocks: [
                            {
                                blockName: 'constellation/group',
                                attrs: {
                                    fontColor: {
                                        default: 'textWhite',
                                    },
                                    justifyContent: {
                                        default: 'center',
                                        lg_lte: 'center',
                                        sm_lte: 'center',
                                    },
                                    margin: {
                                        marginBottom: {
                                            default: 'xl',
                                            sm_lte: '0',
                                        },
                                        marginTop: [],
                                    },
                                    maxWidth: {
                                        default: 'full',
                                        lg_lte: 'xl',
                                    },
                                    padding: {
                                        paddingTop: {
                                            default: 'sm',
                                        },
                                        paddingBottom: {
                                            default: 'sm',
                                            sm_lte: '0',
                                        },
                                        paddingRight: {
                                            default: 'xl',
                                            lg_lte: 'sm',
                                            sm_lte: 'sm',
                                        },
                                        paddingLeft: {
                                            default: 'xl',
                                            lg_lte: 'sm',
                                            sm_lte: 'sm',
                                        },
                                    },
                                    metadata: {
                                        name: 'Group - desktop aligned left',
                                    },
                                    id: 'group-681a7f57-b9ce-4ae5-bd08-856a040bd742',
                                },
                                innerBlocks: [
                                    {
                                        blockName: 'constellation/heading',
                                        attrs: {
                                            content:
                                                '<span class="constellation-text-color constellation-text--textWhite" color="textWhite">Explore your mortgage options in </span><span class="constellation-text-color constellation-text--textGreen" color="textGreen">{State}</span>',
                                            fontType: {
                                                default: 'h3',
                                            },
                                            margin: {
                                                marginTop: [],
                                                marginBottom: {
                                                    default: 'lg',
                                                    lg_lte: 'lg',
                                                    sm_lte: 'xs',
                                                },
                                            },
                                            fontFamily: 'serif',
                                            textAlign: {
                                                default: 'left',
                                                lg_lte: 'left',
                                                sm_lte: 'left',
                                            },
                                            id: 'how-it-works',
                                        },
                                        innerBlocks: [],
                                        innerHTML:
                                            '<h2><span class="constellation-text-color constellation-text--textWhite" color="textWhite">Explore your mortgage options in </span><span class="constellation-text-color constellation-text--textGreen" color="textGreen">{State}</span></h2>',
                                        innerContent: [],
                                    },
                                    {
                                        blockName: 'constellation/grid-layout',
                                        attrs: {
                                            gap: {
                                                default: 'sm',
                                                lg_lte: 'md',
                                                sm_lte: 'md',
                                            },
                                            id: 'grid-layout-42847e07-c4b8-467c-afcb-66cd351cba22',
                                        },
                                        innerBlocks: [
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 2',
                                                        lg_lte: 'span 3',
                                                        sm_lte: 'span 12',
                                                    },
                                                    justifySelf: {
                                                        default: 'stretch',
                                                        lg_lte: 'center',
                                                        sm_lte: 'start',
                                                    },
                                                    alignSelf: {
                                                        default: 'stretch',
                                                        lg_lte: 'stretch',
                                                        sm_lte: 'start',
                                                    },
                                                    alignItems: {
                                                        default: 'flex-start',
                                                    },
                                                    justifyContent: {
                                                        default: 'center',
                                                        lg_lte: 'center',
                                                    },
                                                    id: 'grid-content-6298cd29-b960-4430-84da-327efd45a3d5',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/image',
                                                        attrs: {
                                                            alt: '',
                                                            caption: '',
                                                            height: 130,
                                                            mediaId: 3089,
                                                            sizeSlug: 'full',
                                                            src: 'https://www.zillowstatic.com/bedrock/app/uploads/sites/48/2025/09/man-paperwork-lg.svg',
                                                            width: 130,
                                                            id: 'image-122db8a8-8d3d-4250-92f0-530ff754e51a',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<img src="https://www.zillowstatic.com/bedrock/app/uploads/sites/48/2025/09/man-paperwork-lg.svg" alt="" width="130" height="130">',
                                                        innerContent: [],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 10',
                                                        lg_lte: 'span 9',
                                                        sm_lte: 'span 12',
                                                    },
                                                    justifySelf: {
                                                        lg_lte: 'start',
                                                    },
                                                    alignSelf: {
                                                        default: 'stretch',
                                                    },
                                                    alignItems: {
                                                        default: 'stretch',
                                                        lg_lte: 'stretch',
                                                    },
                                                    justifyContent: {
                                                        default: 'center',
                                                    },
                                                    id: 'grid-content-534721d7-6cd9-409f-8d75-5ce5f07d1225',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/paragraph',
                                                        attrs: {
                                                            content:
                                                                'Loan programs and rates can vary by the state. To learn more about your mortgage affordability in {State}, <strong><span class="constellation-text-color constellation-text--textWhite" color="textWhite"><a href="https://www.zillow.com/homeloans/eligibility/intro/?source=Zillow&amp;channel=Home_Loans&amp;utm_campaign=zhl_homeloanslp_digitalID-stateratelp-pre-approval-inline-cta" rel="" target="" id="link-0666f3ce-bfd4-4d13-bd57-f15495aa48f9">get pre-approved</a></span></strong> with us at Zillow Home Loans. Our trusted loan officers can help you explore your home loan options to understand how <strong><a href="https://www.zillow.com/learn/how-often-do-mortgage-rates-change/" rel="" target="" id="link-72412cef-4b8e-40a8-9a98-68c88cfd80d2">daily rate changes</a></strong><span class="constellation-text-color constellation-text--textWhite" color="textWhite"> in {State} may impact your affordability.</span>',
                                                            fontType: 'large',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<p>Loan programs and rates can vary by the state. To learn more about your mortgage affordability in {State}, <strong><span class="constellation-text-color constellation-text--textWhite" color="textWhite"><a href="https://www.zillow.com/homeloans/eligibility/intro/?source=Zillow&amp;channel=Home_Loans&amp;utm_campaign=zhl_homeloanslp_digitalID-stateratelp-pre-approval-inline-cta" rel="" target="" id="link-0666f3ce-bfd4-4d13-bd57-f15495aa48f9">get pre-approved</a></span></strong> with us at Zillow Home Loans. Our trusted loan officers can help you explore your home loan options to understand how <strong><a href="https://www.zillow.com/learn/how-often-do-mortgage-rates-change/" rel="" target="" id="link-72412cef-4b8e-40a8-9a98-68c88cfd80d2">daily rate changes</a></strong><span class="constellation-text-color constellation-text--textWhite" color="textWhite"> in {State} may impact your affordability.</span></p>',
                                                        innerContent: [],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 12',
                                                        sm_lte: 'span 12',
                                                    },
                                                    id: 'grid-content-39882570-13ba-4c6e-9e44-10a284cefad4',
                                                },
                                                innerBlocks: [],
                                                innerHTML: '',
                                                innerContent: [],
                                            },
                                        ],
                                        innerHTML: '\n\n\n\n\n\n',
                                        innerContent: [
                                            '\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n',
                                        ],
                                    },
                                    {
                                        blockName: 'constellation/grid-layout',
                                        attrs: {
                                            gap: {
                                                default: 'lg',
                                                lg_lte: 'lg',
                                                sm_lte: 'md',
                                            },
                                            alignItems: {
                                                default: 'stretch',
                                            },
                                            id: 'grid-layout-42847e07-c4b8-467c-afcb-66cd351cba22',
                                        },
                                        innerBlocks: [
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 2',
                                                        lg_lte: 'span 3',
                                                        sm_lte: 'span 12',
                                                    },
                                                    justifySelf: {
                                                        default: 'stretch',
                                                        lg_lte: 'center',
                                                        sm_lte: 'start',
                                                    },
                                                    alignSelf: {
                                                        default: 'stretch',
                                                        lg_lte: 'stretch',
                                                        sm_lte: 'center',
                                                    },
                                                    alignItems: {
                                                        default: 'flex-start',
                                                    },
                                                    justifyContent: {
                                                        default: 'flex-start',
                                                        lg_lte: 'center',
                                                    },
                                                    id: 'grid-content-6298cd29-b960-4430-84da-327efd45a3d5',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/image',
                                                        attrs: {
                                                            alt: '',
                                                            caption: '',
                                                            height: 120,
                                                            margin: {
                                                                marginTop: [],
                                                            },
                                                            mediaId: 3090,
                                                            sizeSlug: 'large',
                                                            src: 'https://www.zillowstatic.com/bedrock/app/uploads/sites/48/2025/09/calculator-paperwork.svg',
                                                            width: 120,
                                                            id: 'image-122db8a8-8d3d-4250-92f0-530ff754e51a',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<img src="https://www.zillowstatic.com/bedrock/app/uploads/sites/48/2025/09/calculator-paperwork.svg" alt="" width="120" height="120">',
                                                        innerContent: [],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 10',
                                                        lg_lte: 'span 9',
                                                        sm_lte: 'span 12',
                                                    },
                                                    alignSelf: {
                                                        default: 'stretch',
                                                    },
                                                    justifyContent: {
                                                        default: 'center',
                                                    },
                                                    id: 'grid-content-534721d7-6cd9-409f-8d75-5ce5f07d1225',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/paragraph',
                                                        attrs: {
                                                            content:
                                                                'Check {State} mortgage rates daily to ensure you <a href="https://www.zillow.com/learn/how-to-get-the-lowest-mortgage-rate/" rel="" target="" id="link-ab184dd2-2e2e-4430-af24-f019723a0ccd"><strong>receive the lowest possible rate</strong></a>. You can also use our <a href="https://www.zillow.com/homeloans/buyability/" rel="" target="" id="link-811ae540-8c0c-4305-a74f-a8d7235aff01"><strong>BuyAbility tool</strong></a> to personalize your home search on Zillow. We use current mortgage rates in {State} from Zillow Home Loans to provide you with a real-time estimate, so you know which homes fall within your home buying budget on Zillow. ',
                                                            fontType: 'large',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<p>Check {State} mortgage rates daily to ensure you <a href="https://www.zillow.com/learn/how-to-get-the-lowest-mortgage-rate/" rel="" target="" id="link-ab184dd2-2e2e-4430-af24-f019723a0ccd"><strong>receive the lowest possible rate</strong></a>. You can also use our <a href="https://www.zillow.com/homeloans/buyability/" rel="" target="" id="link-811ae540-8c0c-4305-a74f-a8d7235aff01"><strong>BuyAbility tool</strong></a> to personalize your home search on Zillow. We use current mortgage rates in {State} from Zillow Home Loans to provide you with a real-time estimate, so you know which homes fall within your home buying budget on Zillow. </p>',
                                                        innerContent: [],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                        ],
                                        innerHTML: '\n\n\n\n',
                                        innerContent: [
                                            '\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n',
                                        ],
                                    },
                                ],
                                innerHTML: '\n\n\n\n\n\n',
                                innerContent: [
                                    '\n',
                                    null,
                                    '\n\n',
                                    null,
                                    '\n\n',
                                    null,
                                    '\n',
                                ],
                            },
                        ],
                        innerHTML: '\n\n',
                        innerContent: ['\n', null, '\n'],
                    },
                ],
                innerHTML: '\n\n',
                innerContent: ['\n', null, '\n'],
            },
            {
                blockName: 'constellation/group',
                attrs: {
                    alignItems: {
                        default: 'center',
                        sm_lte: 'stretch',
                    },
                    backgroundColor: {
                        default: 'backgroundWhite',
                    },
                    margin: {
                        marginBottom: {
                            lg_lte: '0',
                            sm_lte: 'lg',
                            default: 'md',
                        },
                        marginTop: {
                            default: 'xl',
                            sm_lte: 'md',
                        },
                    },
                    maxWidth: {
                        default: 'full',
                        sm_lte: 'full',
                    },
                    minHeight: {
                        default: 'short',
                    },
                    padding: {
                        paddingRight: {
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingLeft: {
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingBottom: {
                            default: 'xxl',
                            lg_lte: 'md',
                        },
                        paddingTop: {
                            default: 'xl',
                            lg_lte: 'md',
                        },
                    },
                    className: 'phase-all-not-enrolled',
                    metadata: {
                        name: 'Not Enrolled - Get started',
                    },
                    id: 'group-get-started',
                },
                innerBlocks: [
                    {
                        blockName: 'constellation/group',
                        attrs: {
                            alignItems: {
                                default: 'stretch',
                                lg_lte: 'center',
                            },
                            backgroundColor: {
                                default: 'backgroundWhite',
                            },
                            fontColor: {
                                default: 'textDarkBlue',
                            },
                            justifyContent: {
                                default: 'center',
                                sm_lte: 'flex-start',
                            },
                            margin: {
                                marginBottom: {
                                    lg_lte: 'md',
                                    sm_lte: 'sm',
                                },
                                marginTop: [],
                            },
                            maxWidth: {
                                default: 'xl',
                                lg_lte: 'full',
                                sm_lte: 'lg',
                            },
                            padding: {
                                paddingTop: {
                                    lg_lte: '0',
                                    sm_lte: 'sm',
                                },
                                paddingBottom: {
                                    lg_lte: 'md',
                                    sm_lte: 'sm',
                                },
                                paddingRight: {
                                    default: 'sm',
                                    lg_lte: '0',
                                    sm_lte: '0',
                                },
                                paddingLeft: {
                                    default: 'sm',
                                    lg_lte: '0',
                                    sm_lte: '0',
                                },
                            },
                            metadata: {
                                name: 'Not Enrolled Footer',
                            },
                            id: 'group-b0f994fc-ae88-4ea3-9f7d-245376e807ec',
                        },
                        innerBlocks: [
                            {
                                blockName: 'constellation/card',
                                attrs: {
                                    cardElevation: 0,
                                    cardType: 'secondary',
                                    textAlign: 'center',
                                    backgroundColor: {
                                        default: 'backgroundWhite',
                                    },
                                    padding: {
                                        paddingTop: {
                                            default: 'xxl',
                                            lg_lte: 'xxl',
                                            sm_lte: 'sm',
                                        },
                                        paddingBottom: {
                                            default: 'xxl',
                                            lg_lte: 'xxl',
                                            sm_lte: 'sm',
                                        },
                                        paddingRight: {
                                            default: 'xxl',
                                            lg_lte: 'xxl',
                                            sm_lte: 'xs',
                                        },
                                        paddingLeft: {
                                            default: 'xxl',
                                            lg_lte: 'xxl',
                                            sm_lte: 'xs',
                                        },
                                    },
                                    id: 'card-59ddf43e-7784-49de-a744-ca28dfc520ed',
                                },
                                innerBlocks: [
                                    {
                                        blockName: 'constellation/grid-layout',
                                        attrs: {
                                            gap: {
                                                default: 'xl',
                                                lg_lte: 'md',
                                                sm_lte: 'xs',
                                            },
                                            justifyContent: {
                                                default: 'center',
                                                lg_lte: 'stretch',
                                                sm_lte: 'center',
                                            },
                                            id: 'grid-layout-6c423c88-d018-466d-9cbb-0397b9986bd6',
                                        },
                                        innerBlocks: [
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 6',
                                                        lg_lte: 'span 12',
                                                        sm_lte: 'span 12',
                                                    },
                                                    justifySelf: {
                                                        default: 'stretch',
                                                        lg_lte: 'center',
                                                        sm_lte: 'center',
                                                    },
                                                    alignSelf: {
                                                        default: 'start',
                                                        lg_lte: 'center',
                                                        sm_lte: 'stretch',
                                                    },
                                                    alignItems: {
                                                        default: 'flex-start',
                                                        lg_lte: 'center',
                                                        sm_lte: 'flex-start',
                                                    },
                                                    justifyContent: {
                                                        default: 'flex-start',
                                                        lg_lte: 'flex-start',
                                                        sm_lte: 'flex-start',
                                                    },
                                                    order: {
                                                        lg_lte: '0',
                                                    },
                                                    id: 'grid-content-5cf654e5-2f6a-46a9-9abe-5a869ce05102',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/heading',
                                                        attrs: {
                                                            content:
                                                                'Get a personalized rate with <span class="constellation-text-color constellation-text--textTeal" color="textTeal">BuyAbility℠</span>',
                                                            fontType: {
                                                                default: 'h3',
                                                                sm_lte: 'h4',
                                                            },
                                                            margin: {
                                                                marginTop: [],
                                                                marginBottom: {
                                                                    default:
                                                                        'sm',
                                                                    sm_lte: 'sm',
                                                                },
                                                            },
                                                            fontFamily: 'serif',
                                                            textAlign: {
                                                                default: 'left',
                                                                lg_lte: 'center',
                                                                sm_lte: 'center',
                                                            },
                                                            id: 'footer-heading-not-enrolled',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<h2>Get a personalized rate with <span class="constellation-text-color constellation-text--textTeal" color="textTeal">BuyAbility℠</span></h2>',
                                                        innerContent: [],
                                                    },
                                                    {
                                                        blockName:
                                                            'constellation/paragraph',
                                                        attrs: {
                                                            content:
                                                                'See a rate estimate tailored to you and updated daily so you’re always searching with the latest.',
                                                            textAlign: {
                                                                default: 'left',
                                                                lg_lte: 'center',
                                                                sm_lte: 'center',
                                                            },
                                                            margin: {
                                                                marginBottom:
                                                                    [],
                                                            },
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<p>See a rate estimate tailored to you and updated daily so you’re always searching with the latest.</p>',
                                                        innerContent: [],
                                                    },
                                                    {
                                                        blockName:
                                                            'constellation/group',
                                                        attrs: {
                                                            alignItems: {
                                                                default:
                                                                    'flex-start',
                                                                lg_lte: 'center',
                                                                sm_lte: 'center',
                                                            },
                                                            justifyContent: {
                                                                default:
                                                                    'flex-start',
                                                            },
                                                            margin: {
                                                                marginBottom: {
                                                                    lg_lte: 'md',
                                                                    sm_lte: 'sm',
                                                                },
                                                            },
                                                            padding: {
                                                                paddingTop: {
                                                                    default:
                                                                        'xs',
                                                                    lg_lte: 'xs',
                                                                    sm_lte: 'sm',
                                                                },
                                                                paddingBottom: {
                                                                    lg_lte: 'md',
                                                                    sm_lte: 'sm',
                                                                },
                                                                paddingRight: {
                                                                    lg_lte: 'md',
                                                                    sm_lte: '0',
                                                                },
                                                                paddingLeft: {
                                                                    lg_lte: '0',
                                                                    sm_lte: '0',
                                                                },
                                                            },
                                                            visible: {
                                                                default: true,
                                                                lg_lte: false,
                                                                sm_lte: false,
                                                            },
                                                            id: 'group-7a174c5c-465b-4c4d-8da2-1fee347ad2d7',
                                                        },
                                                        innerBlocks: [
                                                            {
                                                                blockName:
                                                                    'constellation/paragraph',
                                                                attrs: {
                                                                    content:
                                                                        '<strong>Ready to speak with a real person?</strong>',
                                                                    fontType:
                                                                        'body',
                                                                    textAlign: {
                                                                        default:
                                                                            'inherit',
                                                                        lg_lte: 'center',
                                                                        sm_lte: 'center',
                                                                    },
                                                                    margin: {
                                                                        marginBottom:
                                                                            [],
                                                                        marginTop:
                                                                            {
                                                                                default:
                                                                                    'sm',
                                                                            },
                                                                    },
                                                                    id: 'link-FAQ-card',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML:
                                                                    '<p><strong>Ready to speak with a real person?</strong></p>',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/button-group',
                                                                attrs: {
                                                                    conjoined:
                                                                        false,
                                                                    fluid: {
                                                                        default:
                                                                            true,
                                                                        lg_lte: false,
                                                                        sm_lte: true,
                                                                    },
                                                                    justifyContent:
                                                                        {
                                                                            default:
                                                                                'flex-start',
                                                                            sm_lte: 'flex-start',
                                                                        },
                                                                    margin: {
                                                                        marginBottom:
                                                                            {
                                                                                default:
                                                                                    'sm',
                                                                                sm_lte: 'sm',
                                                                            },
                                                                        marginTop:
                                                                            {
                                                                                sm_lte: 'xs',
                                                                                default:
                                                                                    'xs',
                                                                            },
                                                                    },
                                                                    id: 'button-get-started-card',
                                                                },
                                                                innerBlocks: [
                                                                    {
                                                                        blockName:
                                                                            'constellation/button',
                                                                        attrs: {
                                                                            content:
                                                                                'Call us at (855) 917-2501',
                                                                            link: {
                                                                                url: 'tel:8559172501',
                                                                            },
                                                                            component:
                                                                                'TextButton',
                                                                            icon: 'IconSmartphone',
                                                                            iconPosition:
                                                                                'start',
                                                                            className:
                                                                                'button-homeloans-eligibility-left',
                                                                            id: 'button-homeloans-eligibility',
                                                                        },
                                                                        innerBlocks:
                                                                            [],
                                                                        innerHTML:
                                                                            '',
                                                                        innerContent:
                                                                            [],
                                                                    },
                                                                ],
                                                                innerHTML:
                                                                    '\n\n',
                                                                innerContent: [
                                                                    '\n',
                                                                    null,
                                                                    '\n',
                                                                ],
                                                            },
                                                        ],
                                                        innerHTML: '\n\n\n\n',
                                                        innerContent: [
                                                            '\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n',
                                                        ],
                                                    },
                                                ],
                                                innerHTML: '\n\n\n\n\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n\n',
                                                    null,
                                                    '\n\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 6',
                                                        lg_lte: 'span 12',
                                                        sm_lte: 'span 12',
                                                    },
                                                    justifySelf: {
                                                        default: 'stretch',
                                                        lg_lte: 'center',
                                                    },
                                                    alignSelf: {
                                                        default: 'start',
                                                    },
                                                    justifyContent: {
                                                        default: 'flex-end',
                                                    },
                                                    order: {
                                                        lg_lte: '1',
                                                    },
                                                    id: 'grid-content-9d2c743c-d094-44a7-b27f-322f761a515a',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/group',
                                                        attrs: {
                                                            alignItems: {
                                                                default:
                                                                    'stretch',
                                                                lg_lte: 'center',
                                                            },
                                                            justifyContent: {
                                                                default:
                                                                    'center',
                                                                lg_lte: 'flex-start',
                                                            },
                                                            margin: {
                                                                type: 'object',
                                                                default: {
                                                                    marginBottom:
                                                                        {
                                                                            default:
                                                                                'none',
                                                                            lg_lte: 'none',
                                                                            sm_lte: 'none',
                                                                        },
                                                                },
                                                                marginTop: {
                                                                    lg_lte: '0',
                                                                },
                                                            },
                                                            maxWidth: {
                                                                default: 'full',
                                                            },
                                                            padding: {
                                                                type: 'object',
                                                                default: {
                                                                    paddingTop:
                                                                        {
                                                                            default:
                                                                                'none',
                                                                            lg_lte: 'none',
                                                                            sm_lte: 'none',
                                                                        },
                                                                    paddingBottom:
                                                                        {
                                                                            default:
                                                                                'none',
                                                                            lg_lte: 'none',
                                                                            sm_lte: 'none',
                                                                        },
                                                                    paddingRight:
                                                                        {
                                                                            default:
                                                                                'none',
                                                                            lg_lte: 'none',
                                                                            sm_lte: 'none',
                                                                        },
                                                                    paddingLeft:
                                                                        {
                                                                            default:
                                                                                'none',
                                                                            lg_lte: 'none',
                                                                            sm_lte: 'none',
                                                                        },
                                                                },
                                                                paddingLeft: {
                                                                    default:
                                                                        'xl',
                                                                    sm_lte: '0',
                                                                },
                                                                paddingRight: {
                                                                    sm_lte: '0',
                                                                },
                                                                paddingTop: {
                                                                    lg_lte: '0',
                                                                },
                                                            },
                                                            id: 'group-6c619ff9-fa9c-4384-af6f-bd12f2982ec2',
                                                        },
                                                        innerBlocks: [
                                                            {
                                                                blockName:
                                                                    'constellation/group',
                                                                attrs: {
                                                                    margin: {
                                                                        marginBottom:
                                                                            {
                                                                                lg_lte: 'xs',
                                                                                sm_lte: 'sm',
                                                                            },
                                                                    },
                                                                    padding: {
                                                                        paddingTop:
                                                                            {
                                                                                lg_lte: 'xs',
                                                                                sm_lte: 'sm',
                                                                            },
                                                                        paddingBottom:
                                                                            {
                                                                                lg_lte: 'xs',
                                                                                sm_lte: 'sm',
                                                                            },
                                                                        paddingRight:
                                                                            {
                                                                                lg_lte: 'md',
                                                                                sm_lte: 'xs',
                                                                            },
                                                                        paddingLeft:
                                                                            {
                                                                                lg_lte: 'md',
                                                                                sm_lte: 'xs',
                                                                            },
                                                                    },
                                                                    className:
                                                                        'edit-buyability-component footer-buyability-not-enrolled',
                                                                    id: 'group-5e587b06-7a80-4c57-800c-f192240407bf',
                                                                },
                                                                innerBlocks: [
                                                                    {
                                                                        blockName:
                                                                            'cms-frontier/buyability',
                                                                        attrs: {
                                                                            id: 'buyability-61b47eed-84f5-4e1a-be6c-6fd3463bb2cd',
                                                                        },
                                                                        innerBlocks:
                                                                            [],
                                                                        innerHTML:
                                                                            '',
                                                                        innerContent:
                                                                            [],
                                                                    },
                                                                ],
                                                                innerHTML:
                                                                    '\n\n',
                                                                innerContent: [
                                                                    '\n',
                                                                    null,
                                                                    '\n',
                                                                ],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/group',
                                                                attrs: {
                                                                    alignItems:
                                                                        {
                                                                            default:
                                                                                'flex-start',
                                                                            lg_lte: 'center',
                                                                            sm_lte: 'center',
                                                                        },
                                                                    justifyContent:
                                                                        {
                                                                            default:
                                                                                'flex-start',
                                                                        },
                                                                    margin: {
                                                                        marginBottom:
                                                                            {
                                                                                lg_lte: 'md',
                                                                                sm_lte: 'sm',
                                                                            },
                                                                    },
                                                                    padding: {
                                                                        paddingTop:
                                                                            {
                                                                                default:
                                                                                    'xs',
                                                                                lg_lte: 'xs',
                                                                                sm_lte: 'sm',
                                                                            },
                                                                        paddingBottom:
                                                                            {
                                                                                lg_lte: 'md',
                                                                                sm_lte: 'sm',
                                                                            },
                                                                        paddingRight:
                                                                            {
                                                                                lg_lte: 'md',
                                                                                sm_lte: '0',
                                                                            },
                                                                        paddingLeft:
                                                                            {
                                                                                lg_lte: '0',
                                                                                sm_lte: '0',
                                                                            },
                                                                    },
                                                                    visible: {
                                                                        default:
                                                                            false,
                                                                        lg_lte: true,
                                                                        sm_lte: true,
                                                                    },
                                                                    id: 'group-7a174c5c-465b-4c4d-8da2-1fee347ad2d7',
                                                                },
                                                                innerBlocks: [
                                                                    {
                                                                        blockName:
                                                                            'constellation/paragraph',
                                                                        attrs: {
                                                                            content:
                                                                                '<strong>Ready to speak with a real person?</strong>',
                                                                            fontType:
                                                                                'body',
                                                                            textAlign:
                                                                                {
                                                                                    default:
                                                                                        'inherit',
                                                                                    lg_lte: 'center',
                                                                                    sm_lte: 'center',
                                                                                },
                                                                            margin: {
                                                                                marginBottom:
                                                                                    [],
                                                                                marginTop:
                                                                                    {
                                                                                        default:
                                                                                            'sm',
                                                                                    },
                                                                            },
                                                                            id: 'link-FAQ-card',
                                                                        },
                                                                        innerBlocks:
                                                                            [],
                                                                        innerHTML:
                                                                            '<p><strong>Ready to speak with a real person?</strong></p>',
                                                                        innerContent:
                                                                            [],
                                                                    },
                                                                    {
                                                                        blockName:
                                                                            'constellation/button-group',
                                                                        attrs: {
                                                                            fluid: {
                                                                                default:
                                                                                    true,
                                                                                lg_lte: false,
                                                                                sm_lte: true,
                                                                            },
                                                                            justifyContent:
                                                                                {
                                                                                    default:
                                                                                        'flex-start',
                                                                                    sm_lte: 'flex-start',
                                                                                },
                                                                            margin: {
                                                                                marginBottom:
                                                                                    {
                                                                                        default:
                                                                                            'sm',
                                                                                        sm_lte: 'sm',
                                                                                    },
                                                                                marginTop:
                                                                                    {
                                                                                        sm_lte: 'xs',
                                                                                        default:
                                                                                            'xs',
                                                                                    },
                                                                            },
                                                                            id: 'button-get-started-card',
                                                                        },
                                                                        innerBlocks:
                                                                            [
                                                                                {
                                                                                    blockName:
                                                                                        'constellation/button',
                                                                                    attrs: {
                                                                                        content:
                                                                                            'Call us at (855) 917-2501',
                                                                                        link: {
                                                                                            url: 'tel:8559172501',
                                                                                        },
                                                                                        component:
                                                                                            'TextButton',
                                                                                        icon: 'IconSmartphone',
                                                                                        iconPosition:
                                                                                            'start',
                                                                                        id: 'button-homeloans-eligibility',
                                                                                    },
                                                                                    innerBlocks:
                                                                                        [],
                                                                                    innerHTML:
                                                                                        '',
                                                                                    innerContent:
                                                                                        [],
                                                                                },
                                                                            ],
                                                                        innerHTML:
                                                                            '\n\n',
                                                                        innerContent:
                                                                            [
                                                                                '\n',
                                                                                null,
                                                                                '\n',
                                                                            ],
                                                                    },
                                                                ],
                                                                innerHTML:
                                                                    '\n\n\n\n',
                                                                innerContent: [
                                                                    '\n',
                                                                    null,
                                                                    '\n\n',
                                                                    null,
                                                                    '\n',
                                                                ],
                                                            },
                                                        ],
                                                        innerHTML: '\n\n\n\n',
                                                        innerContent: [
                                                            '\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n',
                                                        ],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                        ],
                                        innerHTML: '\n\n\n\n',
                                        innerContent: [
                                            '\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n',
                                        ],
                                    },
                                ],
                                innerHTML: '\n\n',
                                innerContent: ['\n', null, '\n'],
                            },
                        ],
                        innerHTML: '\n\n',
                        innerContent: ['\n', null, '\n'],
                    },
                ],
                innerHTML: '\n\n',
                innerContent: ['\n', null, '\n'],
            },
            {
                blockName: 'constellation/group',
                attrs: {
                    margin: {
                        marginBottom: {
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                    },
                    maxWidth: {
                        default: 'xl',
                        sm_lte: 'xl',
                    },
                    padding: {
                        paddingTop: {
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingBottom: {
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingRight: {
                            lg_lte: 'md',
                            sm_lte: '0',
                        },
                        paddingLeft: {
                            lg_lte: 'md',
                            sm_lte: '0',
                        },
                    },
                    metadata: {
                        name: 'Mortgage Resources',
                    },
                    id: 'group-7f47087c-0490-4d7a-86c5-5488ba8839fc',
                },
                innerBlocks: [
                    {
                        blockName: 'constellation/heading',
                        attrs: {
                            content: 'Mortgage Resources',
                            fontType: {
                                default: 'h3',
                                sm_lte: 'h4',
                            },
                            margin: {
                                marginTop: {
                                    sm_lte: '-md',
                                },
                                marginBottom: {
                                    sm_lte: 'sm',
                                    default: 'md',
                                },
                            },
                            fontFamily: 'serif',
                            textAlign: {
                                default: 'center',
                            },
                            id: 'heading-bd96a09b-8188-4916-b66d-f2d3a94ad60b',
                        },
                        innerBlocks: [],
                        innerHTML: '<h2>Mortgage Resources</h2>',
                        innerContent: [],
                    },
                    {
                        blockName: 'core/block',
                        attrs: {
                            ref: 2565,
                            id: 'block-8fe3c708-1ee0-4adf-9d1b-c9eac40bd559',
                        },
                        innerBlocks: [
                            {
                                blockName: 'constellation/group',
                                attrs: {
                                    margin: {
                                        marginBottom: {
                                            lg_lte: 'md',
                                            sm_lte: 'sm',
                                        },
                                    },
                                    padding: {
                                        paddingTop: {
                                            default: 'lg',
                                            lg_lte: 'md',
                                            sm_lte: 'sm',
                                        },
                                        paddingBottom: {
                                            default: 'lg',
                                            lg_lte: 'md',
                                            sm_lte: 'sm',
                                        },
                                        paddingRight: {
                                            lg_lte: 'md',
                                            sm_lte: 'sm',
                                            default: 'lg',
                                        },
                                        paddingLeft: {
                                            lg_lte: 'md',
                                            sm_lte: 'sm',
                                            default: 'lg',
                                        },
                                    },
                                    metadata: {
                                        name: 'Mortgage Resources',
                                    },
                                    id: 'group-797b87b6-b099-4980-8d14-38698c5db81b',
                                },
                                innerBlocks: [
                                    {
                                        blockName: 'constellation/grid-layout',
                                        attrs: {
                                            gap: {
                                                default: 'xs',
                                                lg_lte: 'md',
                                                sm_lte: 'md',
                                            },
                                            justifyContent: {
                                                default: 'stretch',
                                            },
                                            alignItems: {
                                                default: 'start',
                                            },
                                            id: 'grid-layout-6e48aecc-d2c8-4d92-81d2-43c310a65dd9',
                                        },
                                        innerBlocks: [
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 3',
                                                        sm_lte: 'span 6',
                                                    },
                                                    justifySelf: {
                                                        default: 'start',
                                                        sm_lte: 'stretch',
                                                    },
                                                    alignItems: {
                                                        default: 'flex-start',
                                                        sm_lte: 'flex-start',
                                                    },
                                                    id: 'grid-content-28d2ac0d-3415-4b17-82bd-b8f44874cd30',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/heading',
                                                        attrs: {
                                                            content:
                                                                'Mortgage Rates',
                                                            fontType: {
                                                                default: 'h6',
                                                                lg_lte: 'h6',
                                                            },
                                                            margin: {
                                                                marginTop: {
                                                                    sm_lte: '0',
                                                                },
                                                                marginBottom: {
                                                                    default:
                                                                        'sm',
                                                                },
                                                            },
                                                            textAlign: {
                                                                default: 'left',
                                                                lg_lte: 'center',
                                                                sm_lte: 'left',
                                                            },
                                                            id: 'heading-f7fffe22-f6cf-46b6-962d-d6a83e1ab99c',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<h2>Mortgage Rates</h2>',
                                                        innerContent: [],
                                                    },
                                                    {
                                                        blockName:
                                                            'constellation/list',
                                                        attrs: {
                                                            appearance: 'none',
                                                            verticalSpace: 'md',
                                                            id: 'list-ecfe28e5-08d7-43b5-805e-4897e83c26c8',
                                                        },
                                                        innerBlocks: [
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/" rel="" target="" id="link-154ead2e-9684-42f2-8d4e-985eb1e9387a">Current mortgage rates</a>',
                                                                    id: 'list-item-05433147-2f4b-4f65-bf27-cc0a81e2706c',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/30-year-fixed/" rel="" target="" id="link-f49f20b7-45f2-4d89-93ea-76f3c9bf9e54">30-Year mortgage rates</a>',
                                                                    id: 'link-4column-column1-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-rates/20-year-fixed/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/20-year-fixed/" rel="" target="" id="link-a734e235-ba84-49c1-a5e1-9d5ded9dbbe0">20-year mortgage rates</a>',
                                                                    id: 'link-4column-column1-item4',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-rates/15-year-fixed/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/15-year-fixed/" rel="" target="" id="link-781e3e1d-ba2a-450f-acf0-30ca621bdd8a">15-year mortgage rates</a>',
                                                                    id: 'link-4column-column1-item5',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-rates/10-year-fixed/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/10-year-fixed/" rel="" target="" id="link-751b1bd4-93a8-4c67-aaad-580764c1d1aa">10-year mortgage rates</a>',
                                                                    id: 'link-4column-column1-item6',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/va-mortgage-rates/" rel="" target="" id="link-1b3bbe37-094f-4360-a459-12e1f40a65b0">VA mortgage rates</a>',
                                                                    id: 'link-4column-column1-item9',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/fha-mortgage-rates/" rel="" target="" id="link-7fa24208-4062-44a7-8876-8ef110be832b">FHA mortgage rates</a>',
                                                                    id: 'link-4column-column1-item8',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/jumbo-mortgage-rates/" rel="" target="" id="link-499c5cb6-5c15-4496-9439-ec71e5f9f788">Jumbo mortgage rates</a>',
                                                                    id: 'link-4column-column1-item7',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/7-year-arm/" rel="" target="" id="link-d914c5cd-5e23-4cc1-86b1-4f55ad975b27">7-year ARM rates</a>',
                                                                    id: 'link-4column-column1-item12',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                        ],
                                                        innerHTML:
                                                            '\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
                                                        innerContent: [
                                                            '\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n',
                                                        ],
                                                    },
                                                ],
                                                innerHTML: '\n\n\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 3',
                                                        sm_lte: 'span 6',
                                                    },
                                                    justifySelf: {
                                                        default: 'start',
                                                        sm_lte: 'stretch',
                                                    },
                                                    alignSelf: {
                                                        default: 'None',
                                                    },
                                                    alignItems: {
                                                        default: 'flex-start',
                                                        sm_lte: 'flex-start',
                                                    },
                                                    id: 'grid-content-c092c5f8-4172-4a78-892f-ef0e193968b3',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/heading',
                                                        attrs: {
                                                            content:
                                                                'Mortgage Options',
                                                            fontType: {
                                                                default: 'h6',
                                                                lg_lte: 'h6',
                                                            },
                                                            margin: {
                                                                marginTop: {
                                                                    sm_lte: '0',
                                                                },
                                                                marginBottom: {
                                                                    default:
                                                                        'sm',
                                                                },
                                                            },
                                                            textAlign: {
                                                                default: 'left',
                                                                lg_lte: 'center',
                                                                sm_lte: 'left',
                                                            },
                                                            id: 'heading-005ec4ce-4ab7-4282-9b1e-f08d8c3f3baf',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<h2>Mortgage Options</h2>',
                                                        innerContent: [],
                                                    },
                                                    {
                                                        blockName:
                                                            'constellation/list',
                                                        attrs: {
                                                            appearance: 'none',
                                                            verticalSpace: 'md',
                                                            id: 'list-0655396a-a49a-415f-a502-8b2ac5f974b8',
                                                        },
                                                        innerBlocks: [
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/first-time-buyer-loan-programs/" rel="" target="" id="link-1953435d-404c-42d6-b990-5879a7e3acc0" class="constellation-link"><a href="https://www.zillow.com/homeloans/" rel="" target="" id="link-609d2e96-c99d-4f47-8a5c-62bde573b185" class="constellation-link">Zillow Home Loans</a></a>',
                                                                    id: 'link-4column-column2-item10',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/eligibility/intro/" rel="" target="" id="link-7b9f2a48-f8b1-415f-9a52-3f5e0e3fd6ca" class="constellation-link">Get pre-qualified</a>',
                                                                    id: 'link-4column-column2-item10',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/conventional-loan/" rel="" target="" id="link-124ed6c1-8f49-4d61-b835-275aecb62b10" class="constellation-link">Conventional loans</a>',
                                                                    id: 'link-4column-column2-item10',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-learning/fha-loan/"></a><a href="https://www.zillow.com/learn/fha-loan/" rel="" target="" id="link-ccf786ad-7769-43b5-84f8-e9547218f8bf" class="constellation-link">FHA loans</a>',
                                                                    id: 'link-4column-column2-item5',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-learning/adjustable-rate-mortgage/"></a><a href="https://www.zillow.com/learn/adjustable-rate-mortgage/" rel="" target="" id="link-d938c763-040f-4358-952e-b7a1e6bb6eec" class="constellation-link">ARM loans</a>',
                                                                    id: 'link-4column-column2-item6',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-learning/va-home-loans/"></a><a href="https://www.zillow.com/learn/va-home-loans/" rel="" target="" id="link-cf599e29-9ac3-4f5d-bf40-5ef2560dad06" class="constellation-link">VA loans</a>',
                                                                    id: 'link-4column-column2-item7',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/what-are-jumbo-loans/" rel="" target="" id="link-9236659f-3970-44d0-9e9e-5a9ee3a91a61" class="constellation-link">Jumbo loans</a>',
                                                                    id: 'link-4column-column2-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/first-time-buyer-loan-programs/" rel="" target="" id="link-7afaf7c1-d7f4-4b33-bbac-b1a7f1ec1de4" class="constellation-link">First-time home buyer programs</a>',
                                                                    id: 'link-4column-column2-item2',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/down-payment-assistance/" rel="" target="" id="link-c3601d9d-2e3e-4731-ba4c-67a147ad61c8" class="constellation-link">How to get down payment assistance</a>',
                                                                    id: 'link-4column-column2-item3',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                        ],
                                                        innerHTML:
                                                            '\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
                                                        innerContent: [
                                                            '\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n',
                                                        ],
                                                    },
                                                ],
                                                innerHTML: '\n\n\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 3',
                                                        sm_lte: 'span 6',
                                                    },
                                                    justifySelf: {
                                                        default: 'center',
                                                        sm_lte: 'stretch',
                                                    },
                                                    alignItems: {
                                                        default: 'flex-start',
                                                        sm_lte: 'center',
                                                    },
                                                    id: 'grid-content-caed4006-16d4-430f-b21b-6a5574fc0294',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/heading',
                                                        attrs: {
                                                            content:
                                                                'Mortgage Calculators',
                                                            fontType: {
                                                                default: 'h6',
                                                                lg_lte: 'h6',
                                                            },
                                                            textAlign: {
                                                                default: 'left',
                                                                lg_lte: 'center',
                                                                sm_lte: 'left',
                                                            },
                                                            id: 'heading-09933e45-024f-42c6-8e8c-1883afe91b09',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<h2>Mortgage Calculators</h2>',
                                                        innerContent: [],
                                                    },
                                                    {
                                                        blockName:
                                                            'constellation/list',
                                                        attrs: {
                                                            appearance: 'none',
                                                            verticalSpace: 'md',
                                                            id: 'list-2fe383dc-22f1-4422-9e81-5357498b3d83',
                                                        },
                                                        innerBlocks: [
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/" rel="" target="" id="link-e6d1518d-e677-4e32-897e-46ac849a96b8" class="constellation-link">Mortgage calculator</a>',
                                                                    id: 'link-4column-column3-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/house-affordability/" rel="" target="" id="link-8395b584-3d57-47a3-8c39-924f330a63ba" class="constellation-link">Affordability calculator</a>',
                                                                    id: 'link-4column-column3-item4',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/debt-to-income-calculator/" rel="" target="" id="link-208c0e41-0003-4360-a6f3-6c3b5804e86a" class="constellation-link">Debt-to-income calculator</a>',
                                                                    id: 'link-4column-column3-item2',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/va/" rel="" target="" id="link-8957ae30-1a85-4c08-b293-8f6eaf09f8c2" class="constellation-link">VA mortgage calculator</a>',
                                                                    id: 'link-4column-column3-item3',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/fha-loan-calculator/" rel="" target="" id="link-075435ff-1fc7-4d92-bc74-10cfffa2694e" class="constellation-link">FHA mortgage calculator</a>',
                                                                    id: 'link-4column-column3-item8',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/property-tax-calculator/" rel="" target="" id="link-cfe2b052-3f7d-4c08-a1e0-8f4bdc2a2dda" class="constellation-link">Property tax calculator</a>',
                                                                    id: 'link-4column-column3-item8',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/amortization-schedule-calculator/" rel="" target="" id="link-408fddc1-a9a8-490a-9c98-b421c0b8ced0" class="constellation-link">Amortization calculator</a>',
                                                                    id: 'link-4column-column3-item8',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/closing-cost-calculator/" rel="" target="" id="link-f217a1fb-bc0c-4e42-a461-1b21592d3e4a" class="constellation-link">Closing cost calculator</a>',
                                                                    id: 'link-4column-column3-item8',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/down-payment-calculator/" rel="" target="" id="link-7b79133b-79ac-4419-9034-79b41fb5d7bf" class="constellation-link">Down payment calculator</a>',
                                                                    id: 'link-4column-column3-item8',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/loan-comparison-calculator/" rel="" target="" id="link-073b7f02-1c9e-4bc2-837e-964f758a6821" class="constellation-link">Loan comparison calculator</a>',
                                                                    id: 'link-4column-column3-item8',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                        ],
                                                        innerHTML:
                                                            '\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
                                                        innerContent: [
                                                            '\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n',
                                                        ],
                                                    },
                                                ],
                                                innerHTML: '\n\n\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 3',
                                                        sm_lte: 'span 6',
                                                    },
                                                    justifySelf: {
                                                        default: 'center',
                                                        sm_lte: 'stretch',
                                                    },
                                                    alignItems: {
                                                        default: 'flex-start',
                                                        sm_lte: 'center',
                                                    },
                                                    id: 'grid-content-1626fb47-617f-49ab-8b09-6472ccc868d5',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/heading',
                                                        attrs: {
                                                            content:
                                                                'Mortgage Resources',
                                                            fontType: {
                                                                default: 'h6',
                                                                lg_lte: 'h6',
                                                            },
                                                            textAlign: {
                                                                default: 'left',
                                                                lg_lte: 'center',
                                                                sm_lte: 'left',
                                                            },
                                                            id: 'heading-94a10f02-d9d5-44fb-b2d4-69b2a3e6a138',
                                                        },
                                                        innerBlocks: [],
                                                        innerHTML:
                                                            '<h2>Mortgage Resources</h2>',
                                                        innerContent: [],
                                                    },
                                                    {
                                                        blockName:
                                                            'constellation/list',
                                                        attrs: {
                                                            appearance: 'none',
                                                            verticalSpace: 'md',
                                                            id: 'list-8a83e2cb-c7e0-4ee0-9507-ed4efa1aba8e',
                                                        },
                                                        innerBlocks: [
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/mortgage-application-paperwork/" rel="" target="" id="link-9aa18c83-9d3d-4d16-96f2-aca79df8ccf0" class="constellation-link">Mortgage application process</a>',
                                                                    id: 'link-4column-column4-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/how-to-get-a-mortgage/" rel="" target="" id="link-43298495-7ffa-4d18-bace-48357d8acc86" class="constellation-link">How to get a mortgage</a>',
                                                                    id: 'link-4column-column4-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/when-to-get-mortgage-preapproval/" rel="" target="" id="link-d803c4dd-8a5c-4c26-8842-0241c6362368" class="constellation-link">When to get pre-approved for a mortgage?</a>',
                                                                    id: 'link-4column-column4-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/documents-needed-for-mortgage-preapproval/" rel="" target="" id="link-e29a8461-0904-44e6-8c14-a024114e154a" class="constellation-link">What documents do you need for mortgage pre-approval?</a>',
                                                                    id: 'link-4column-column4-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/how-long-is-mortgage-preapproval-good-for/" rel="" target="" id="link-2a7bb993-2cf4-40d7-8355-6c7973ff9a8d" class="constellation-link">How long is mortgage pre-approval good for?</a>',
                                                                    id: 'link-4column-column4-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/pre-qualification-vs-pre-approval/" rel="" target="" id="link-caeafbb8-cc6d-42c5-8861-930d77651b28" class="constellation-link">Pre-qualified vs pre-approved: what\'s the difference?</a>',
                                                                    id: 'link-4column-column4-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/how-long-does-underwriting-take/" rel="" target="" id="link-5e11d9e1-47ad-4656-91a8-b180518e779f" class="constellation-link">How long does mortgage underwriting take?</a>',
                                                                    id: 'link-4column-column4-item2',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/percentage-of-income-for-mortgage/" rel="" target="" id="link-f522f9bd-3cfa-4872-aa08-cdbc8bd6c7f7" class="constellation-link">What percentage of your income should go to a mortgage?</a>',
                                                                    id: 'link-4column-column4-item3',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/learn/mortgage-credit-scores/" rel="" target="" id="link-aa4984b1-2070-4728-a764-cbf01dbd53a0" class="constellation-link">What credit score is needed to buy a house?</a>',
                                                                    id: 'link-4column-column4-item4',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                        ],
                                                        innerHTML:
                                                            '\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
                                                        innerContent: [
                                                            '\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n',
                                                        ],
                                                    },
                                                ],
                                                innerHTML: '\n\n\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                        ],
                                        innerHTML: '\n\n\n\n\n\n\n\n',
                                        innerContent: [
                                            '\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n',
                                        ],
                                    },
                                ],
                                innerHTML: '\n\n',
                                innerContent: ['\n', null, '\n'],
                            },
                        ],
                        innerHTML:
                            '\n\n\n<h2>Mortgage Rates</h2>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n<h2>Mortgage Options</h2>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n<h2>Mortgage Calculators</h2>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n<h2>Mortgage Resources</h2>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
                        innerContent: [],
                    },
                ],
                innerHTML: '\n\n\n\n',
                innerContent: ['\n', null, '\n\n', null, '\n'],
            },
            {
                blockName: 'constellation/group',
                attrs: {
                    maxWidth: {
                        default: 'full',
                    },
                    padding: {
                        paddingTop: {
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingBottom: {
                            default: 'lg',
                            lg_lte: 'md',
                            sm_lte: 'sm',
                        },
                        paddingRight: {
                            lg_lte: 'md',
                            sm_lte: '0',
                        },
                        paddingLeft: {
                            lg_lte: 'md',
                            sm_lte: '0',
                        },
                    },
                    metadata: {
                        name: 'Current Mortgage Rates by State 2',
                    },
                    id: 'states-block-id',
                },
                innerBlocks: [
                    {
                        blockName: 'constellation/heading',
                        attrs: {
                            content: 'Current Mortgage Rates by State',
                            fontType: {
                                default: 'h3',
                                sm_lte: 'h4',
                            },
                            margin: {
                                marginTop: {
                                    sm_lte: '-md',
                                },
                                marginBottom: {
                                    sm_lte: 'sm',
                                    default: 'md',
                                },
                            },
                            fontFamily: 'serif',
                            textAlign: {
                                default: 'center',
                            },
                            id: 'heading-bd96a09b-8188-4916-b66d-f2d3a94ad60b',
                        },
                        innerBlocks: [],
                        innerHTML: '<h2>Current Mortgage Rates by State</h2>',
                        innerContent: [],
                    },
                    {
                        blockName: 'core/block',
                        attrs: {
                            ref: 2556,
                            id: 'block-293dd9b4-4f18-4d06-a3ed-56f8841b0e99',
                        },
                        innerBlocks: [
                            {
                                blockName: 'constellation/group',
                                attrs: {
                                    margin: {
                                        marginBottom: {
                                            lg_lte: 'md',
                                            sm_lte: 'sm',
                                        },
                                        marginTop: {
                                            sm_lte: '0',
                                        },
                                    },
                                    padding: {
                                        paddingTop: {
                                            default: 'lg',
                                            lg_lte: 'md',
                                            sm_lte: '0',
                                        },
                                        paddingBottom: {
                                            default: 'lg',
                                            lg_lte: 'md',
                                            sm_lte: 'sm',
                                        },
                                        paddingRight: {
                                            default: 'lg',
                                            lg_lte: 'md',
                                            sm_lte: 'sm',
                                        },
                                        paddingLeft: {
                                            default: 'lg',
                                            lg_lte: 'md',
                                            sm_lte: 'sm',
                                        },
                                    },
                                    metadata: {
                                        name: 'Mortgage Rates by State',
                                    },
                                    id: 'group-72806ae9-feba-4b65-a2fa-fb9277cd37a8',
                                },
                                innerBlocks: [
                                    {
                                        blockName: 'constellation/grid-layout',
                                        attrs: {
                                            gap: {
                                                default: 'xs',
                                                lg_lte: 'md',
                                                sm_lte: 'md',
                                            },
                                            justifyContent: {
                                                default: 'stretch',
                                                sm_lte: 'stretch',
                                            },
                                            alignItems: {
                                                default: 'start',
                                            },
                                            id: 'grid-layout-6e48aecc-d2c8-4d92-81d2-43c310a65dd9',
                                        },
                                        innerBlocks: [
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 3',
                                                        sm_lte: 'span 6',
                                                    },
                                                    justifySelf: {
                                                        default: 'center',
                                                        sm_lte: 'stretch',
                                                    },
                                                    alignSelf: {
                                                        sm_lte: 'stretch',
                                                    },
                                                    alignItems: {
                                                        default: 'center',
                                                        sm_lte: 'flex-start',
                                                    },
                                                    order: {
                                                        sm_lte: '0',
                                                    },
                                                    id: 'grid-content-28d2ac0d-3415-4b17-82bd-b8f44874cd30',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/list',
                                                        attrs: {
                                                            appearance: 'none',
                                                            verticalSpace: 'md',
                                                            id: 'list-ecfe28e5-08d7-43b5-805e-4897e83c26c8',
                                                        },
                                                        innerBlocks: [
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/" rel="" target="" id="link-292149c6-0822-4b98-8e7c-85d4ab97feb6" class="constellation-link">United States</a>',
                                                                    id: 'link-4column-column1-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/refinance/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/alabama/" rel="" target="" id="link-17f4b40a-66f6-4ddc-a5a7-476168d2fc5e">Alabama</a>',
                                                                    id: 'link-4column-column1-item2',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-rates/30-year-fixed/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/alaska/" rel="" target="" id="link-8c960901-7626-47a1-be6b-f07c2c9af051">Alaska</a>',
                                                                    id: 'link-4column-column1-item3',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-rates/20-year-fixed/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/arizona/" rel="" target="" id="link-7a3ea7f3-ced4-4a12-8fa8-268be2a917ff">Arizona</a>',
                                                                    id: 'link-4column-column1-item4',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-rates/15-year-fixed/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/arkansas/" rel="" target="" id="link-9f005c55-db5b-4ca4-9033-65ba3b7c3ee5">Arkansas</a>',
                                                                    id: 'link-4column-column1-item5',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-rates/10-year-fixed/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/california/" rel="" target="" id="link-33754ab7-683f-4c26-92df-9840c403e5eb">California</a>',
                                                                    id: 'link-4column-column1-item6',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/colorado/" rel="" target="" id="link-0a2a95d3-0bfc-42f8-bd0f-c3f7372ee2b1">Colorado</a>',
                                                                    id: 'link-4column-column1-item7',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/connecticut/" rel="" target="" id="link-4f019f6c-500e-49f2-88ee-fe3383b7cdc7">Connecticut</a>',
                                                                    id: 'link-4column-column1-item8',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-rates/7-year-arm/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/delaware/" rel="" target="" id="link-fbc7b749-749a-4e16-a84a-0b7ae619173f">Delaware</a>',
                                                                    id: 'link-4column-column1-item9',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-rates/5-year-arm/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/florida/" rel="" target="" id="link-a296c1c8-a1fe-4059-a519-3b3d9c81e4de">Florida</a>',
                                                                    id: 'link-4column-column1-item10',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-rates/3-year-arm/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/georgia/" rel="" target="" id="link-a1f65c8e-fbed-4c9c-b331-084415365a34">Georgia</a>',
                                                                    id: 'link-4column-column1-item11',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/hawaii/" rel="" target="" id="link-0b57fe0c-62a9-49ad-9f05-399c1e6efd3f">Hawaii</a>',
                                                                    id: 'link-4column-column1-item12',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/idaho/" rel="" target="" id="link-4f353469-c3c1-43d2-b446-1d45c1388efd">Idaho</a>',
                                                                    id: 'link-4column-column1-item13',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                        ],
                                                        innerHTML:
                                                            '\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
                                                        innerContent: [
                                                            '\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n',
                                                        ],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 3',
                                                        sm_lte: 'span 6',
                                                    },
                                                    justifySelf: {
                                                        default: 'center',
                                                        sm_lte: 'stretch',
                                                    },
                                                    alignItems: {
                                                        default: 'center',
                                                        sm_lte: 'flex-start',
                                                    },
                                                    order: {
                                                        sm_lte: '2',
                                                    },
                                                    id: 'grid-content-c092c5f8-4172-4a78-892f-ef0e193968b3',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/list',
                                                        attrs: {
                                                            appearance: 'none',
                                                            verticalSpace: 'md',
                                                            id: 'list-0655396a-a49a-415f-a502-8b2ac5f974b8',
                                                        },
                                                        innerBlocks: [
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/illinois/" rel="" target="" id="link-f4714cb8-d206-4c0a-a8f3-26a534f8ba7f">Illinois</a>',
                                                                    id: 'link-4column-column2-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgages/pre-approval/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/indiana/" rel="" target="" id="link-03b2c790-5eea-41f0-aafa-c3d143906e58">Indiana</a>',
                                                                    id: 'link-4column-column2-item2',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgages/pre-qualify/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/iowa/" rel="" target="" id="link-488812ff-5949-40f9-b6cf-2ff3312d5430">Iowa</a>',
                                                                    id: 'link-4column-column2-item3',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/kansas/" rel="" target="" id="link-10c09469-1d79-495b-b988-1696209b6679">Kansas</a>',
                                                                    id: 'link-4column-column2-item4',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/kentucky/" rel="" target="" id="link-191078a0-0348-4605-bf65-ff413f3c8c0a">Kentucky</a>',
                                                                    id: 'link-4column-column2-item5',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/louisiana/" rel="" target="" id="link-e594abaf-9435-41ea-9afb-c9f9eadcfbb3">Louisiana</a>',
                                                                    id: 'link-4column-column2-item6',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/maine/" rel="" target="" id="link-20e17140-6970-478a-902e-c83fb7221729">Maine</a>',
                                                                    id: 'link-4column-column2-item7',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/maryland/" rel="" target="" id="link-cf599e29-9ac3-4f5d-bf40-5ef2560dad06">Maryland</a>',
                                                                    id: 'link-4column-column2-item8',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/massachusetts/" rel="" target="" id="link-1a5259fc-8f82-494d-8a07-9381f6714a0d">Massachusetts</a>',
                                                                    id: 'link-4column-column2-item9',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/michigan/" rel="" target="" id="link-37cda329-2a61-4432-8059-0d783ba7a373">Michigan</a>',
                                                                    id: 'link-4column-column2-item10',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/minnesota/" rel="" target="" id="link-505a7647-9980-47a6-a2ad-7c6318155770">Minnesota</a>',
                                                                    id: 'link-4column-column2-item11',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/mississippi/" rel="" target="" id="link-2e2b870a-501d-435b-8642-0cd6e5f0d959">Mississippi</a>',
                                                                    id: 'link-4column-column2-item12',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgages/heloc/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/missouri/" rel="" target="" id="link-cb5b84c3-6bd2-4b8a-a922-0bd022f0a93c">Missouri</a>',
                                                                    id: 'link-4column-column2-item13',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                        ],
                                                        innerHTML:
                                                            '\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
                                                        innerContent: [
                                                            '\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n',
                                                        ],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 3',
                                                        sm_lte: 'span 6',
                                                    },
                                                    justifySelf: {
                                                        default: 'None',
                                                        sm_lte: 'stretch',
                                                    },
                                                    alignSelf: {
                                                        default: 'center',
                                                    },
                                                    alignItems: {
                                                        default: 'center',
                                                        sm_lte: 'flex-start',
                                                    },
                                                    order: {
                                                        sm_lte: '1',
                                                    },
                                                    id: 'grid-content-caed4006-16d4-430f-b21b-6a5574fc0294',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/list',
                                                        attrs: {
                                                            appearance: 'none',
                                                            verticalSpace: 'md',
                                                            id: 'list-2fe383dc-22f1-4422-9e81-5357498b3d83',
                                                        },
                                                        innerBlocks: [
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/montana/" rel="" target="" id="link-9c533184-4d41-4acc-a18a-173669165259">Montana</a>',
                                                                    id: 'link-4column-column3-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/house-affordability/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/nebraska/" rel="" target="" id="link-4daae138-2625-42cb-9e0b-bd0b18e751a1">Nebraska</a>',
                                                                    id: 'link-4column-column3-item2',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/debt-to-income-calculator/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/nevada/" rel="" target="" id="link-9c51c68a-fab3-4c41-a62d-3c0efc6d00a7">Nevada</a>',
                                                                    id: 'link-4column-column3-item3',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/va/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/new-hampshire/" rel="" target="" id="link-be407294-c494-4d63-9043-34103e1701e8">New Hampshire</a>',
                                                                    id: 'link-4column-column3-item4',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/new-jersey/" rel="" target="" id="link-bf4e1269-7dc3-425f-a782-3621cce63a88">New Jersey</a>',
                                                                    id: 'link-4column-column3-item5',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/new-mexico/" rel="" target="" id="link-51961213-f5b8-4d78-a1ae-9a08c612e71a">New Mexico</a>',
                                                                    id: 'link-4column-column3-item6',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-rates/ny/" rel="" target="" id="link-0d2457f9-62c2-40c0-afb4-8006f3e97db4">New York</a>',
                                                                    id: 'link-4column-column3-item7',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/mortgage-calculator/amortization-schedule-calculator/"></a><a href="https://www.zillow.com/homeloans/mortgage-rates/north-carolina/" rel="" target="" id="link-549e4b09-e783-47cd-855a-acbcaa9a45f0">North Carolina</a>',
                                                                    id: 'link-4column-column3-item8',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/north-dakota/" rel="" target="" id="link-ca41000a-4345-4603-bf18-63a8db0bfeab">North Dakota</a>',
                                                                    id: 'link-4column-column3-item9',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/ohio/" rel="" target="" id="link-e74274c7-09f4-40fe-bc61-af6f7ab838bc">Ohio</a>',
                                                                    id: 'link-4column-column3-item10',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/oklahoma/" rel="" target="" id="link-c8ca6cfc-63f6-4271-8808-fb65e292a801">Oklahoma</a>',
                                                                    id: 'link-4column-column3-item12',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/oregon/" rel="" target="" id="link-1509d09e-376d-46f9-9d4e-f931b81cb3ff">Oregon</a>',
                                                                    id: 'link-4column-column3-item13',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/pennsylvania/" rel="" target="" id="link-1509d09e-376d-46f9-9d4e-f931b81cb3ff">Pennsylvania</a>',
                                                                    id: 'link-4column-column3-item14',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                        ],
                                                        innerHTML:
                                                            '\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
                                                        innerContent: [
                                                            '\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n',
                                                        ],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                            {
                                                blockName:
                                                    'constellation/grid-content',
                                                attrs: {
                                                    gridColumnEnd: {
                                                        default: 'span 3',
                                                        sm_lte: 'span 6',
                                                    },
                                                    justifySelf: {
                                                        sm_lte: 'stretch',
                                                    },
                                                    alignSelf: {
                                                        default: 'center',
                                                    },
                                                    alignItems: {
                                                        default: 'center',
                                                        sm_lte: 'flex-start',
                                                    },
                                                    order: {
                                                        sm_lte: '3',
                                                    },
                                                    id: 'grid-content-1626fb47-617f-49ab-8b09-6472ccc868d5',
                                                },
                                                innerBlocks: [
                                                    {
                                                        blockName:
                                                            'constellation/list',
                                                        attrs: {
                                                            appearance: 'none',
                                                            verticalSpace: 'md',
                                                            id: 'list-8a83e2cb-c7e0-4ee0-9507-ed4efa1aba8e',
                                                        },
                                                        innerBlocks: [
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/rhode-island/" rel="" target="" id="link-988ac1a3-b2d6-4667-b817-1bd3f120f733">Rhode Island</a>',
                                                                    id: 'link-4column-column4-item1',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/south-carolina/" rel="" target="" id="link-2198b718-b053-4296-b219-bf9e6a6d4b0b">South Carolina</a>',
                                                                    id: 'link-4column-column4-item2',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/south-dakota/" rel="" target="" id="link-c9352c6c-8cc5-4283-a6fc-8fe7d2498689">South Dakota</a>',
                                                                    id: 'link-4column-column4-item3',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/tennessee/" rel="" target="" id="link-a488d291-bb3d-44b7-ab53-ebb7849f6904">Tennessee</a>',
                                                                    id: 'link-4column-column4-item4',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/texas/" rel="" target="" id="link-7fc8969c-18e0-4669-ad09-c509e603918d">Texas</a>',
                                                                    id: 'link-4column-column4-item5',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/utah/" rel="" target="" id="link-f48f6876-45ed-44c1-9a4f-591b8569891c">Utah</a>',
                                                                    id: 'link-4column-column4-item6',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/vermont/" rel="" target="" id="link-1cda74f3-0780-4aa2-963c-188c7e4fa2de">Vermont</a>',
                                                                    id: 'link-4column-column4-item7',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/virginia/" rel="" target="" id="link-e1e507bc-f9e0-4543-9527-ae7e17f7ee9b">Virginia</a>',
                                                                    id: 'link-4column-column4-item8',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/washington/" rel="" target="" id="link-5a659ed7-52e0-4dfc-a391-c4db296f223b">Washington</a>',
                                                                    id: 'link-4column-column4-item9',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/west-virginia/" rel="" target="" id="link-fa2f17f4-44dc-4c97-84e9-6cef7c1c414f">West Virginia</a>',
                                                                    id: 'link-4column-column4-item10',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/wisconsin/" rel="" target="" id="link-4935b4e0-1868-4ca0-8cb4-59703c112a6b">Wisconsin</a>',
                                                                    id: 'link-4column-column4-item11',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/wyoming/" rel="" target="" id="link-e05f25e7-a94b-498f-8636-31eb29c919fc">Wyoming</a>',
                                                                    id: 'link-4column-column4-item12',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                            {
                                                                blockName:
                                                                    'constellation/list-item',
                                                                attrs: {
                                                                    content:
                                                                        '<a href="https://www.zillow.com/homeloans/mortgage-rates/washington-dc/" rel="" target="" id="link-120d0a4f-3837-409c-8bf9-30d3288f5828">Washington D.C.</a>',
                                                                    id: 'link-4column-column4-item13',
                                                                },
                                                                innerBlocks: [],
                                                                innerHTML: '',
                                                                innerContent:
                                                                    [],
                                                            },
                                                        ],
                                                        innerHTML:
                                                            '\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
                                                        innerContent: [
                                                            '\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n\n',
                                                            null,
                                                            '\n',
                                                        ],
                                                    },
                                                ],
                                                innerHTML: '\n\n',
                                                innerContent: [
                                                    '\n',
                                                    null,
                                                    '\n',
                                                ],
                                            },
                                        ],
                                        innerHTML: '\n\n\n\n\n\n\n\n',
                                        innerContent: [
                                            '\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n\n',
                                            null,
                                            '\n',
                                        ],
                                    },
                                ],
                                innerHTML: '\n\n',
                                innerContent: ['\n', null, '\n'],
                            },
                        ],
                        innerHTML:
                            '\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
                        innerContent: [],
                    },
                ],
                innerHTML: '\n\n\n\n',
                innerContent: ['\n', null, '\n\n', null, '\n'],
            },
        ],
        innerHTML: '\n\n\n\n\n\n\n\n\n\n\n\n\n\n',
        innerContent: [
            '\n',
            null,
            '\n\n',
            null,
            '\n\n',
            null,
            '\n\n',
            null,
            '\n\n',
            null,
            '\n\n',
            null,
            '\n\n',
            null,
            '\n',
        ],
    },
];
